var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-timeline-item',[_c(_vm.timelineIconComponent.component,_vm._b({tag:"component",attrs:{"slot":"dot"},slot:"dot"},'component',_vm.timelineIconComponent.props,false)),_vm._v(" "),_c(_vm.timelineContentComponent.component,_vm._g({tag:"component",attrs:{"history":_vm.history,"show-relate-link":_vm.showRelateLink}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }